// Очередь in-app тостов — UI-эфемерное состояние app-ui (SPEC §4.5/§101). Тосты появляются на новое
// входящее в НЕ-активном НЕ-muted чате (FR-NOTIF-02), на ошибки действий, на обновление SW. Очередь и
// её жизненный цикл (авто-скрытие) — целиком наши; никакой сети тут нет.

import type { ChatId, MessageId } from '@tele-chat/shared-contracts'

export type ToastKind = 'message' | 'error' | 'info' | 'update'

export interface ToastAction {
  label: string
  run(): void
}

export interface Toast {
  id: string
  kind: ToastKind
  title: string
  body?: string
  /** Для message-тоста — куда вести по тапу. */
  chatId?: ChatId
  messageId?: MessageId
  /** Доп. действие (напр. «Обновить» для update). */
  action?: ToastAction
  /** Авто-скрытие через мс; 0 — не скрывать автоматически (требует действия). */
  ttlMs: number
  createdAt: number
  /** Ключ дедупликации: тост с таким же ключом ЗАМЕНЯЕТ прежний, не плодит копии (напр. 'sw-update'). */
  dedupeKey?: string
}

/** Дефолтные TTL по типам (мс). */
export const TOAST_TTL: Record<ToastKind, number> = {
  message: 5000,
  error: 6000,
  info: 4000,
  update: 0, // обновление — пока пользователь не нажмёт
}

export type ToastInput = Omit<Toast, 'id' | 'createdAt' | 'ttlMs'> & { ttlMs?: number }
